/*
 * @Author: Yun
 * @Date: 2025-09-24 13:57:04
 * @Last Modified by: Yun.WU
 * @Last Modified time: 2026-05-15 17:02:16
 */

// 引入所有静态资源
import img1 from '@assets/images/showcase/img1.jpg';
import img2 from '@assets/images/showcase/img2.jpg';
import img3 from '@assets/images/showcase/img3.jpg';
import img4 from '@assets/images/showcase/img4.jpg';
import img5 from '@assets/images/showcase/img5.jpg';
import img6 from '@assets/images/showcase/img6.jpg';
import img7 from '@assets/images/showcase/img7.jpg';
import img8 from '@assets/images/showcase/img8.jpg';
import heroBg1 from '@assets/images/hero/bg1.png';
import heroBg2 from '@assets/images/hero/bg2.png';
import timelineMountain from '@assets/images/timeline/1.png';
import timelineCloud1 from '@assets/images/timeline/cloud1.png';
import timelineCloud2 from '@assets/images/timeline/cloud2.png';
import timelineTreemap from '@assets/images/timeline/treemap.jpg';
import timelineTreemapMobile from '@assets/images/timeline/treemap_m.jpg';
import highlightBg from '@assets/images/highlight/bg.png';
import highlightImg1 from '@assets/images/highlight/img1.png';
import highlightImg2 from '@assets/images/highlight/img2.jpg';
import highlightImg3 from '@assets/images/highlight/img3.jpg';
import highlightImg4 from '@assets/images/highlight/img4.jpg';
import highlightImg5 from '@assets/images/highlight/img5.jpg';
import rightPathImg1 from '@assets/images/rightpath/img1.png';
import rightPathImg2 from '@assets/images/rightpath/img2.png';
import rightPathImg3 from '@assets/images/rightpath/img3.png';
import rightPathImg4 from '@assets/images/rightpath/img4.png';
import rightPathImg5 from '@assets/images/rightpath/img5.png';
import product2016 from '@assets/images/product/2016.jpg';
import product2017 from '@assets/images/product/2017.jpg';
import product2018 from '@assets/images/product/2018.jpg';
import product2019 from '@assets/images/product/2019.jpg';
import product2020 from '@assets/images/product/2020.jpg';
import product2021 from '@assets/images/product/2021.jpg';
import product2022 from '@assets/images/product/2022.jpg';
import product2023 from '@assets/images/product/2023.jpg';
import product2024 from '@assets/images/product/2024.jpg';
import productBg from '@assets/images/product/bg.jpg';
import videocover from '@assets/images/videocover.jpg';
import cgtnLogo from '@assets/images/cgtn.png';

// 引入环境配置
import { getWxShareImgUrl } from '@configs/env';
import { title } from 'process';

/**
 * ========== NavBar组件内容配置 ==========
 */
export const navBarContent = {
    logo: cgtnLogo,
    navItems: [
        {
            id: 'nav-1',
            label: 'New Year Message',
            sectionId: 'hero',
        },
        /* {
            id: 'nav-2',
            label: 'Indelible Memories',
            sectionId: 'highlight',
        }, */
        {
            id: 'nav-2',
            label: 'Domestic Agenda',
            sectionId: 'timeline',
        },
        {
            id: 'nav-3',
            label: "China's Diplomacy",
            sectionId: 'rightpath',
        },
        {
            id: 'nav-4',
            label: 'Year by Year',
            sectionId: 'product',
        },
    ],
};

/**
 * ========== Hero组件内容配置（合并Video组件）==========
 */
export const heroContent = {
    // 文案配置
    text: {
        mainTitle: "MEETING THE PEOPLE'S ASPIRATIONS",
        vip: '2026 New Year Message',
        leftSectionTitle: 'Chinese President Xi Jinping\'s',
        quote: "As far as Chinese modernization is concerned, the people's well-being matters the most.",
    },
    // 资源配置
    assets: {
        firstCoverBg: heroBg1,
        backgroundImageTop: heroBg1,
        backgroundImageBottom: heroBg2,
        videoSrc:
            'https://video.cgtn.com/news/2025-12-31/Chinese-President-Xi-Jinping-delivers-2026-New-Year-message-1Jywr2SDKQ8/video/wu_1jdq1sqtue2i1undrcvhf913d611f2/wu_1jdq1sqtue2i1undrcvhf913d611f2.m3u8',
        posterImage: videocover,
        // 开屏切片图片
        sliceImages: [highlightImg1, highlightImg2, highlightImg3, highlightImg4, highlightImg5],
        sliceImagesMobile: [highlightImg1, highlightImg3, highlightImg5],
    },
    // JWPlayer配置
    jwplayer: {
        key: '44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK',
    },
};

/**
 * ========== HighLight组件内容配置 ==========
 */
export const highLightContent = {
    // 背景图
    background: highlightBg,
    // 文案配置
    title: '\'Indelible Memories\'',
    subtitle: 'President Xi cast 2025 as a year of "indelible memories" for China in his New Year message. Below, we look back at five extraordinary stories that marked a truly memorable year.',
    // 豆腐块数据配置
    items: [
        {
            id: 1,
            image: highlightImg1,
            caption: 'Robots Running',
            newsContent: {
                title: "Ready, set, robot! China hosts world's first humanoid half-marathon",
                article: [
                    "History was made on the streets of Beijing on April 19, 2025, as the world's inaugural humanoid half-marathon pushed robotic endurance to its absolute limit.",
                    'With a winning time of 2:40:42, the Tiangong Ultra outperformed a diverse field of competitors in a race where the finish line mattered less than the occasion itself: the dawn of a new era in global technology.',
                    "Serving as a high-profile launchpad for China's burgeoning robotics sector, the event proved to be a watershed for the industry, transforming science fiction into a tangible, high-performance reality.",
                ],
                highlights: ['Humanoid robots racing', 'a reality', 'production and daily life', 'rapid growth', 'versatile applications'],
            },
        },
        {
            id: 2,
            image: highlightImg2,
            caption: 'Museum Milestone',
            newsContent: {
                title: 'Lively, chic and open: Palace Museum marks 100 years of living heritage',
                article: [
                    'Located in a once forbidden domain, the Palace Museum marked a historic milestone on October 10, 2025, celebrating 100 years since it first opened its gates to the public.',
                    'Today, the over 600-year-old Ming and Qing dynasties complex is more than a relic of the past; it is a global cultural titan, hosting exhibitions from across the world.',
                    "Against the iconic backdrop of crimson walls and golden tiles, museumgoers – it received 17.6 million visits in 2024 – have donned traditional attire, transforming this imperial site into a vibrant, living bridge between China's epic history and its modern youth.",
                ],
                highlights: ['100th founding anniversary', 'World Cultural Heritage', 'largest and most intact', 'most-visited'],
            },
        },
        {
            id: 3,
            image: highlightImg3,
            caption: 'Peace Parade',
            newsContent: {
                title: 'Peace prevails: China holds V-Day parade to mark 80 years of WWII victory',
                article: [
                    "China held a massive military parade at Tiananmen Square in Beijing on September 3, 2025, as part of its commemorations on the 80th anniversary of the victory of the Chinese People's War of Resistance Against Japanese Aggression and the World Anti-Fascist War.",
                    "Addressing the grand gathering, President Xi Jinping reaffirmed China's commitment to a path of peaceful development in a world fraught with turbulence and uncertainty.",
                    "Following Japan's official surrender on September 2, 1945, China's historic victory has been viewed by scholars as a definitive turning point, marking the pivotal transition from a century of decline to an era of rejuvenation.",
                ],
                highlights: ['massive', 'peaceful development', 'first country', 'one-third'],
            },
        },
        {
            id: 4,
            image: highlightImg4,
            caption: 'Electromagnetic Era',
            newsContent: {
                title: 'The Fujian: China commissions first electromagnetic catapult aircraft carrier',
                article: [
                    "China commissioned its first aircraft carrier equipped with electromagnetic catapults, the Fujian, in Sanya City, south China's Hainan Province, on November 5, 2025.",
                    'In a landmark breakthrough, the Chinese Navy announced on September 22, 2025 that the J-15T, J-35 and KongJing-600 carrier-based aircraft had successfully completed their inaugural electromagnetic catapult-assisted takeoff and arrested landing training on the Fujian.',
                    "Independently designed and built, the Fujian, one of China's three carriers currently in service,  represents a massive leap in domestic engineering and a new chapter in the country's naval capabilities.",
                ],
                highlights: [
                    'electromagnetic catapult-assisted takeoff',
                    'another breakthrough',
                    'leaping forward',
                    'world-class force at sea',
                ],
            },
        },
        {
            id: 5,
            image: highlightImg5,
            caption: 'Green Gold',
            newsContent: {
                title: 'Green is gold: China marks 20 years of its ecological philosophy',
                article: [
                    'August 15, 2025 marked the 20th anniversary of China\'s green growth philosophy, one rooted in the  "two mountains" concept that "lucid waters and lush mountains are invaluable assets."',
                    'The "two mountains" concept, which literally means green mountains and clear waters are as valuable as mountains of gold and silver, has become a guiding principle for China\'s ecological efforts.',
                    'Two decades on, its influence has transcended borders, shaping both local landscapes and the way the world envisions a greener, more sustainable future.',
                ],
                highlights: ['green development', 'renewable energy', 'high-quality growth', 'high-level environmental protection'],
            },
        },
    ],
};

/**
 * ========== TimeLine组件内容配置 ==========
 */
export const timeLineContent = {
    // 文案配置
    text: {
        defaultTitle: 'DOMESTIC AGENDA',
        middleContent: {
            title: 'Key Meetings',
            description: [
                "Transition and continuity were twin features of China's domestic governance in 2025, as the country marked the final lap of the 14th Five-Year Plan (FYP) and set the stage for a new chapter.",
                "Following more than eight months of drafting, the leadership of the Communist Party of China (CPC) adopted its recommendations for formulating the 15th FYP (2026-2030) at a key plenum in October, outlining China's economic and social development priorities for the upcoming five years.",
                "Chinese President Xi Jinping's 2025 domestic agenda was marked by his 10 inspection tours, from the country's northeastern reaches of Liaoning to the southern shores of Hainan, and from the northwestern part of Xinjiang to the eastern metropolis of Shanghai.",
                'The importance of "Chinese modernization" and "high-quality development" were emphasized by Xi during his inspections, highlighting the country\'s relentless efforts to advance Chinese modernization on all fronts with high-quality development as its primary driving force, according to an analysis by CGTN.',
                'Technological innovation, reform and opening up, Party self-governance, people\'s well-being, ecology, culture, social governance and manufacturing were other top topics Xi highlighted on different visits.',
                "Another CGTN analysis of the year's key high-level meetings, including those of the Political Bureau of the CPC Central Committee, revealed a clear set of strategic priorities for China's decision-makers: modernization, development, and the 15th FYP.",
            ],
        },
    },
    // 背景和视差元素配置
    visuals: {
        groundBackground: timelineMountain,
        cloudElements: [
            {
                id: 'cloud-1',
                image: timelineCloud1,
            },
            {
                id: 'cloud-2',
                image: timelineCloud2,
            },
        ],
    },

    // 高频词配置
    visualization: {
        treemapImage: timelineTreemap,
        treemapImageMobile: timelineTreemapMobile,
        keywords: [
            {
                name: 'Modernization',
                color: '#031545',
                value: 80,
                description: "China met the targets in its 14th Five-Year Plan for economic and social development, and made solid advances on the new journey of Chinese modernization – a key term defining China's journey to rejuvenation.",
            },
            {
                name: 'High-quality development',
                color: '#072e6c',
                value: 58,
                description: "China's continued progress in high-quality development in 2025 was powered by innovation and a sustained shift toward green growth, offering significant value to the world.",
            },
            {
                name: 'Economic and social development',
                color: '#05378c',
                value: 45,
                description: "China's economy pushed forward with innovation-led and high-quality development in 2025 despite mounting pressures. The major targets and tasks of economic and social development were achieved.",
            },
            {
                name: '15th Five-Year Plan',
                color: '#134b99',
                value: 42,
                description: "The 15th Five-Year Plan (2026-2030) period plays a pivotal connecting role. The targets set for 2026-2030 and the progress made during these five years will be decisive in determining whether China can basically achieve socialist modernization by 2035.",
            },
            {
                name: 'Economic work',
                color: '#1b60aa',
                value: 39,
                description: "Boosted by the adoption of more proactive and effective macro policies, China's economy grew by 5% in 2025, serving as one of the most stable and reliable engines of world economic growth.",
            },
            {
                name: 'Party self-governance',
                color: '#175aa7',
                value: 35,
                description: "In 2025, the Communist Party of China exercised strict self-governance through credible measures, and promoted the Party's self-revolution to fight corruption and advance healthy governance.",
            },
            {
                name: 'Sci-tech innovation',
                color: '#4587c7',
                value: 24,
                description: "China made notable strides in sci-tech innovations in 2025, including in humanoid robotics, new energy vehicles and the AI industry. These achievements strongly promoted high-quality development and enabled China to become a major pillar in global innovation.",
            },
            {
                name: 'New quality productive forces',
                color: '#62ade1',
                value: 19,
                description: "From electric manned airships to brain-computer interface devices, China saw a wave of first-of-their-kind breakthroughs across multiple sectors in 2025. Together, these developments point to the steady growth of new quality productive forces that are helping build a stronger foundation for economic growth.",
            },
            {
                name: 'Fighting corruption',
                color: '#2c77ba',
                value: 27,
                description: "Throughout 2025, China's anti-corruption campaign continued with undiminished intensity, targeting officials at all levels and advancing efforts to repatriate fugitives and recover misappropriated funds.",
            },
            {
                name: 'Urban work',
                color: '#62ade1',
                value: 19,
                description: "China made solid progress in promoting urban renewal work in 2025 amid the nation's continued efforts to make its cities greener and more livable, renovating 27,100 old urban residential communities, and benefiting 4.99 million households.",
            }
        ],
        legendTitle: 'Top Policy Themes from Key Meetings in 2025',
        legendText: [
            'This treemap shows the top 10 policy themes from 2025. Each category is color-coded and proportionally sized based on the number of times the topic appears in official reports: the larger the block, the more frequently the theme appears. Meanwhile, the numbers reflect cumulative mentions for the year.'
        ],
    },

    // 旭日图配置
    sunburstChart: {
        title: "Xi's Domestic Tours in 2025",
        description: [
            "This interactive sunburst chart visualizes Chinese President Xi Jinping's 10 domestic inspection tours of 2025.",
            "The inner ring, moving clockwise from Liaoning, tracks the regions visited in chronological order. Hover over the outer ring to view the top three high-frequency policy themes extracted from official reports, with segment width reflecting the term's prevalence during that visit.",
        ],
        tips: 'Click any region to uncover the specific priorities that defined each tour.',
        firstInfo: {
            description: 'Inside China\'s domestic agenda: Key priorities from Xi\'s inspections and meetings in 2025',
            url: 'https://news.cgtn.com/news/2025-12-30/Inside-China-s-domestic-agenda-Key-priorities-in-2025-1JwoKjSgzQs/p.html'
        },
        data: {
            name: 'root',
            children: [
                {
                    name: 'Liaoning',
                    color: '#FF6915',
                    month: 'January',
                    description: 'Xi Jinping inspects NE China city ahead of Spring Festival',
                    url: 'https://news.cgtn.com/news/2025-01-23/Xi-Jinping-inspects-NE-China-city-ahead-of-Spring-Festival-1AoYc4MXfl6/index.html',
                    children: [
                        { name: 'New Year greetings', value: 7 },
                        { name: 'Visit those in need', value: 3 },
                        { name: 'Full revitalization of the Northeast', value: 3 },
                    ],
                },
                {
                    name: 'Guizhou',
                    color: '#FF7D12',
                    month: 'March',
                    description: 'Xi Jinping visits ethnic village in Guizhou for rural revitalization',
                    url: 'https://news.cgtn.com/news/2025-03-18/Xi-Jinping-visits-ethnic-village-in-Guizhou-for-rural-revitalization-1BPU2AHdYRO/p.html',
                    children: [
                        { name: 'Culture and tourism', value: 14 },
                        { name: 'High-quality development', value: 6 },
                        { name: 'Chinese modernization', value: 5 },
                    ],
                },
                {
                    name: 'Yunnan',
                    color: '#FDA923',
                    month: 'March',
                    description: 'Xi Jinping urges opening new ground for development during inspection tour in Yunnan',
                    url: 'https://news.cgtn.com/news/2025-03-20/Xi-Jinping-urges-opening-new-ground-for-development-in-Yunnan-1BTKuJhtoAw/p.html',
                    children: [
                        { name: 'Culture and tourism', value: 10 },
                        { name: 'Ethnic affairs', value: 7 },
                        { name: 'Promoting reform and innovation', value: 3 },
                    ],
                },
                {
                    name: 'Shanghai',
                    color: '#8ED36C',
                    month: 'April',
                    description: 'Xi Jinping inspects AI industry in Shanghai, calling for its development',
                    url: 'https://news.cgtn.com/news/2025-04-29/Xi-inspects-AI-industry-in-Shanghai-calling-for-its-development-1CXZD4Yuc6c/p.html',
                    children: [
                        { name: 'Artificial intelligence', value: 10 },
                        { name: 'Global South', value: 8 },
                        { name: 'Technological innovation', value: 5 },
                    ],
                },
                {
                    name: 'Henan',
                    color: '#56C15F',
                    month: 'May',
                    description: 'Xi Jinping stresses firm confidence in high-quality development during Henan inspection tour',
                    url: 'https://news.cgtn.com/news/2025-05-20/President-Xi-stresses-firm-confidence-in-high-quality-development--1DwPtyUUQc8/p.html',
                    children: [
                        { name: 'High-quality development', value: 8 },
                        { name: 'Social governance', value: 7 },
                        { name: 'A modern industrial system', value: 5 },
                    ],
                },
                {
                    name: 'Shanxi',
                    color: '#43A86C',
                    month: 'July',
                    description: 'Xi Jinping stresses transforming resource-based economy, Chinese modernization during Shanxi tour',
                    url: 'https://news.cgtn.com/news/2025-07-08/Xi-stresses-transforming-resource-based-economy-in-Shanxi-inspection-1EQcPH1r6zm/p.html',
                    children: [
                        { name: 'Hundred-Regiment Campaign', value: 4 },
                        { name: 'Transformation and development', value: 4 },
                        { name: 'Great spirit of resisting aggression', value: 4 },
                    ],
                },
                {
                    name: 'Xizang Autonomous Region',
                    color: '#169980',
                    month: 'August',
                    description: 'Xi Jinping stresses building modern socialist new Xizang',
                    url: 'https://news.cgtn.com/news/2025-08-20/President-Xi-Jinping-stresses-building-modern-socialist-new-Xizang-1FZMm5n13vG/p.html',
                    children: [
                        { name: 'Socialist modernization', value: 4 },
                        { name: 'New Xizang', value: 3 },
                        { name: 'High-quality development', value: 2 },
                    ],
                },
                {
                    name: 'Xinjiang Uygur Autonomous Region',
                    color: '#107777',
                    month: 'September',
                    description: 'Xi Jinping stresses building socialist modern Xinjiang',
                    url: 'https://news.cgtn.com/news/2025-09-24/Xi-stresses-building-socialist-modern-Xinjiang-1GVQwgs8oFO/p.html',
                    children: [
                        { name: 'A community for the Chinese nation', value: 4 },
                        { name: 'Socialist modernization', value: 4 },
                        { name: 'Guidelines for governing Xinjiang', value: 3 },
                    ],
                },
                {
                    name: 'Hainan',
                    color: '#5757AD',
                    month: 'November',
                    description: 'Xi Jinping stresses adopting high standards for building Hainan Free Trade Port',
                    url: 'https://news.cgtn.com/news/2025-11-06/Xi-stresses-high-standards-for-building-Hainan-Free-Trade-Port-1I4XheR29IQ/index.html',
                    children: [
                        { name: 'Aircraft carrier Fujian', value: 11 },
                        { name: 'Free Trade Port', value: 15 },
                        { name: 'Opening up', value: 6 },
                    ],
                },
                {
                    name: 'Guangdong',
                    color: '#7B6996',
                    month: 'November',
                    description: 'Xi Jinping urges deepening reform, opening up during Guangdong inspection tour',
                    url: 'https://news.cgtn.com/news/2025-11-08/Xi-urges-deepening-reform-opening-up-during-Guangdong-inspection-tour-1I8doD5lnqg/p.html',
                    children: [
                        {
                            name: 'Guiding principles of the fourth plenary session of the 20th CPC Central Committee',
                            value: 4,
                        },
                        { name: 'Comprehensively deepening reform and opening up', value: 4 },
                        { name: 'High-quality development', value: 4 },
                    ],
                },
            ],
        },
        // Tooltip 文案配置
        tooltipLabels: {
            frequency: 'Frequency',
            province: 'Province',
            month: 'Month',
        },
    },
};

/**
 * ========== RightPath组件内容配置 ==========
 */
export const rightPathContent = {
    // 文案配置
    title: "China's Diplomacy",
    // 按钮文案
    backButtonText: 'Back',
    learnMoreButtonText: 'Learn more',
    // 介绍文案配置
    intro: {
        title: 'Building a Community with a Shared Future for Humanity',
        content: [
            'In an extraordinary year defined by escalating friction and global volatility, China in 2025 stood firm as a vital anchor of stability.',
            'This year marked a landmark "China moment" in global governance, defined by the Global Governance Initiative proposed by President Xi during the Shanghai Cooperation Organization Tianjin Summit on September 1.',
            "Another pivotal chapter followed as leaders and representatives from across five continents gathered in Beijing on September 3 for the commemorations of the 80th anniversary of the victory of the Chinese People's War of Resistance Against Japanese Aggression and the World Anti-Fascist War, reflecting broad recognition of China's contributions to WWII victory and its unwavering commitment to upholding the post-war international order.",
            "China continued to prioritize neighborhood in its diplomacy in 2025, holding the first central conference on work related to neighboring countries on April 8-9. Xi's diplomatic travels, from Southeast Asia on April 14-18 to Russia on May 7-10, and from Central Asia on June 16-18 to the Republic of Korea on October 30-November 1, sketched a clear map of China's strategic priorities.",
            'In 2025, head-of-state diplomacy once again proved to be the anchor of China-U.S. relations. With one presidential face-to-face meeting, four presidential calls, and five rounds of economic and trade consultations, China and the U.S. not only set the tone for bilateral relations, but also cemented the foundations for cooperation and a stable relationship.',
        ],
    },
    // 卡片数据配置
    items: [
        {
            id: 1,
            image: rightPathImg1,
            title: 'Global Public Goods',
            description:
                "The four initiatives proposed by China – including the Global Governance Initiative, put forward in September 2025 – underline the country's efforts to reinforce the concept of building a community with a shared future for humanity, and reflect Chinese experience and solutions in participating in the global governance system.",
            url: 'https://news.cgtn.com/news/2025-12-12/How-China-s-global-initiatives-help-build-a-sustainable-better-world-1J2Ke7BbcTC/p.html',
        },
        {
            id: 2,
            image: rightPathImg2,
            title: 'Friendly Neighborhood',
            description:
                "Chinese President Xi Jinping repeatedly highlighted China's vision of building a community with a shared future with neighboring countries in 2025, underscoring the country's determination to foster an amicable, secure and prosperous future with its neighbors.",
            url: 'https://news.cgtn.com/news/2025-12-13/How-China-s-neighborhood-diplomacy-promotes-shared-development-1J4jaYmyPQc/p.html',
        },
        {
            id: 3,
            image: rightPathImg3,
            title: 'Major-Country Stability',
            description:
                'In a turbulent year around the world, China demonstrated responsibility in 2025 by stabilizing major-power relations, advancing cooperation with Russia, the United States and the European Union, and contributing to global governance.',
            url: 'https://news.cgtn.com/news/2025-12-14/How-China-played-a-responsible-role-in-a-year-of-global-uncertainty-1J5wCcJ8zBK/p.html',
        },
        {
            id: 4,
            image: rightPathImg4,
            title: 'South-South Cooperation',
            description:
                "China expanded South-South cooperation through new multilateral mechanisms, practical development projects and growing engagement in agriculture, industry and green technology in 2025. Backed by UN partnerships and guided by President Xi Jinping's calls for multilateralism and fairness, these efforts aim to support capacity building and sustainable development across the Global South.",
            url: 'https://news.cgtn.com/news/2025-12-16/How-China-works-with-the-UN-to-drive-South-South-cooperation-1J8aBDl6fu0/p.html',
        },
        {
            id: 5,
            image: rightPathImg5,
            title: 'Climate Action',
            description:
                'In 2025, China, with its steadfast commitment and remarkable progress in green development, emerged as a champion in the global transition to renewable energy, shining bright as a beacon of hope in the fight against climate change.',
            url: 'https://news.cgtn.com/news/2025-12-16/How-green-development-is-shaping-the-future-of-China-and-the-world-1J9nsUJ75W8/p.html',
        },
    ],
};

/**
 * ========== ProductCollection组件内容配置 ==========
 */
export const productCollectionContent = {
    background: productBg,
    items: [
        {
            year: 2024,
            image: product2024,
            title: "People's Well-Being Matters Most",
            url: 'https://news.cgtn.com/event/2024/China2024/index.html',
        },
        {
            year: 2023,
            image: product2023,
            title: 'Chinese Modernization, Global Opportunities',
            url: 'https://news.cgtn.com/event/2023/China2023/index.html',
        },
        {
            year: 2022,
            image: product2022,
            title: 'New Journey of the New Era',
            url: 'https://news.cgtn.com/event/2022/China2022/index.html',
        },
        {
            year: 2021,
            image: product2021,
            title: 'Seeking Happiness for the People',
            url: 'https://news.cgtn.com/event/2021/China2021/index.html',
        },
        { year: 2020, image: product2020, title: "China's Decisive Year", url: 'https://news.cgtn.com/event/2020/decisiveyear/index.html' },
        {
            year: 2019,
            image: product2019,
            title: "Modernizing China's Governance",
            url: 'https://news.cgtn.com/event/2019/China2019/index.html',
        },
        {
            year: 2018,
            image: product2018,
            title: "China's Reform and Opening up in the New Era",
            url: 'https://news.cgtn.com/event/2018/China2018/index.html',
        },
        { year: 2017, image: product2017, title: 'New Era for China', url: 'https://cp.cgtn.com/' },
        { year: 2016, image: product2016, title: 'The Governance of China', url: 'https://cp.cgtn.com/2016/' },
    ],
};

/**
 * ========== Showcase组件内容配置 ==========
 */
export const showcaseContent = {
    // 渐变色配置
    gradients: [
        'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
        'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
        'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
        'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
        'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
    ],
    // 内容数据配置
    contentData: [
        {
            image: img1,
            title: 'First',
            text: 'Advanced deep learning algorithms that mimic human brain functions.',
            altText: 'Neural Networks',
        },
        {
            image: img2,
            title: 'Second',
            text: 'Intelligent systems that learn and improve from experience automatically.',
            altText: 'Neural Networks',
        },
        {
            image: img3,
            title: 'Third',
            text: 'AI technology that enables machines to interpret visual information.',
            altText: 'Computer Vision',
        },
        {
            image: img4,
            title: 'Fourth',
            text: 'Processing human language to enable seamless communication with AI.',
            altText: 'Natural Language',
        },
        {
            image: img5,
            title: 'Fifth',
            text: 'Intelligent automation systems for industrial and personal applications.',
            altText: 'Robotics AI',
        },
        {
            image: img6,
            title: 'Sixth',
            text: 'Advanced algorithms for extracting insights from complex datasets.',
            altText: 'Data Analytics',
        },
        {
            image: img7,
            title: 'Seventh',
            text: 'Distributed AI processing for real-time intelligent applications.',
            altText: 'Edge Computing',
        },
        {
            image: img8,
            title: 'Eighth',
            text: 'Next-generation computing combining quantum mechanics with AI.',
            altText: 'Quantum AI',
        },
    ],
    // 默认文案配置（初始显示）
    defaultText: {
        title: 'Neural Networks',
        description: 'Advanced deep learning algorithms that mimic human brain functions.',
    },
};

/**
 * ========== App组件内容配置 ==========
 */
export const appContent = {
    // 移动端占位文案
    mobile: {
        title: 'Mobile Version Coming Soon...',
        description: 'Please visit on PC for the complete experience',
    },
    // 微信分享配置
    wxShare: {
        title: 'MEETING THE PEOPLE\'S ASPIRATIONS',
        desc: ' ',
        getImgUrl: () => getWxShareImgUrl(),
    },
};

/**
 * ========== PhotoFlow组件内容配置 ==========
 */
export const photoFlowContent = {
    // 文案配置
    text: {
        sectionTitle: 'Blabla Photography',
        sectionSubtitle: 'Exploring moments through photography',
    },
    // 照片配置
    photos: {
        // 三列瀑布流的图片数据
        columns: [
            // 第一列图片
            [
                {
                    id: 'photo-1-1',
                    url: 'https://picsum.photos/400/700?random=101',
                    alt: 'Portrait Photo 1-1',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-1-2',
                    url: 'https://picsum.photos/400/700?random=102',
                    alt: 'Portrait Photo 1-2',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-1-3',
                    url: 'https://picsum.photos/400/700?random=103',
                    alt: 'Portrait Photo 1-3',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-1-4',
                    url: 'https://picsum.photos/400/700?random=104',
                    alt: 'Portrait Photo 1-4',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-1-5',
                    url: 'https://picsum.photos/400/700?random=105',
                    alt: 'Portrait Photo 1-5',
                    aspectRatio: 'portrait',
                },
            ],
            // 第二列图片
            [
                {
                    id: 'photo-2-1',
                    url: 'https://picsum.photos/400/700?random=201',
                    alt: 'Portrait Photo 2-1',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-2-2',
                    url: 'https://picsum.photos/400/700?random=202',
                    alt: 'Portrait Photo 2-2',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-2-3',
                    url: 'https://picsum.photos/400/700?random=203',
                    alt: 'Portrait Photo 2-3',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-2-4',
                    url: 'https://picsum.photos/400/700?random=204',
                    alt: 'Portrait Photo 2-4',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-2-5',
                    url: 'https://picsum.photos/400/700?random=205',
                    alt: 'Portrait Photo 2-5',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-2-6',
                    url: 'https://picsum.photos/400/700?random=206',
                    alt: 'Portrait Photo 2-6',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-2-7',
                    url: 'https://picsum.photos/400/700?random=207',
                    alt: 'Portrait Photo 2-7',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-2-8',
                    url: 'https://picsum.photos/400/700?random=208',
                    alt: 'Portrait Photo 2-8',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-2-9',
                    url: 'https://picsum.photos/400/700?random=209',
                    alt: 'Portrait Photo 2-9',
                    aspectRatio: 'portrait',
                },
            ],
            // 第三列图片
            [
                {
                    id: 'photo-3-1',
                    url: 'https://picsum.photos/400/700?random=301',
                    alt: 'Portrait Photo 3-1',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-3-2',
                    url: 'https://picsum.photos/400/700?random=302',
                    alt: 'Portrait Photo 3-2',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-3-3',
                    url: 'https://picsum.photos/400/700?random=303',
                    alt: 'Portrait Photo 3-3',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-3-4',
                    url: 'https://picsum.photos/400/700?random=304',
                    alt: 'Portrait Photo 3-4',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-3-5',
                    url: 'https://picsum.photos/400/700?random=305',
                    alt: 'Portrait Photo 3-5',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-3-6',
                    url: 'https://picsum.photos/400/700?random=306',
                    alt: 'Portrait Photo 3-6',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-3-7',
                    url: 'https://picsum.photos/400/700?random=307',
                    alt: 'Portrait Photo 3-7',
                    aspectRatio: 'portrait',
                },
                {
                    id: 'photo-3-8',
                    url: 'https://picsum.photos/400/700?random=308',
                    alt: 'Portrait Photo 3-8',
                    aspectRatio: 'portrait',
                },
            ],
        ],
    },
};

/**
 * ========== SpotlightGallery组件内容配置 ==========
 */
export const spotlightGalleryContent = {
    // 文案配置
    text: {
        title: 'Creative Vision',
        subtitle: 'Discover extraordinary moments through our curated collection of visual storytelling',
    },
    // 图片配置 - 4张单独的大图
    images: {
        single: [
            {
                id: 'spotlight-1',
                url: 'https://picsum.photos/600/800?random=401',
                alt: 'Creative Vision 1',
            },
            {
                id: 'spotlight-2',
                url: 'https://picsum.photos/600/800?random=402',
                alt: 'Creative Vision 2',
            },
            {
                id: 'spotlight-3',
                url: 'https://picsum.photos/600/800?random=403',
                alt: 'Creative Vision 3',
            },
            {
                id: 'spotlight-4',
                url: 'https://picsum.photos/600/800?random=404',
                alt: 'Creative Vision 4',
            },
        ],
    },
};

/**
 * ========== StatisticsBoard组件内容配置 ==========
 */
export const statisticsBoardContent = {
    // 文案配置
    text: {
        defaultTitle: '2025 Annual Overview',
        defaultSubtitle: 'Achievements that define our journey and growth throughout the year',
    },
    // 统计数据配置
    data: [
        {
            id: 'stat-1',
            number: 2025,
            suffix: '',
            label: 'Remarkable Year',
            description: 'A year filled with challenges and opportunities',
            animationDelay: 0,
            isYear: true, // 标识为年份，不添加千分位逗号
            startNumber: 2020, // 从2020年开始动画到2025年
        },
        {
            id: 'stat-2',
            number: 365,
            suffix: ' Days',
            label: 'Continuous Effort',
            description: 'Every day is a new beginning',
            animationDelay: 0.1,
        },
        {
            id: 'stat-3',
            number: 1000000,
            suffix: '+',
            label: 'Trusted Users',
            description: 'Millions of users chose to trust us',
            animationDelay: 0.2,
        },
        {
            id: 'stat-4',
            number: 50,
            suffix: '%',
            label: 'Growth Rate',
            description: 'Annual growth exceeding expectations',
            animationDelay: 0.3,
        },
        {
            id: 'stat-5',
            number: 24,
            suffix: ' Hours',
            label: 'Round-the-Clock',
            description: '7×24 non-stop support and service',
            animationDelay: 0.4,
        },
        {
            id: 'stat-6',
            number: 99.9,
            suffix: '%',
            label: 'Uptime',
            description: 'Ultra-high availability guarantee',
            animationDelay: 0.5,
        },
    ],
};

/**
 * ========== MagneticCards组件内容配置 ==========
 */
export const magneticCardsContent = {
    // 文案配置
    text: {
        defaultTitle: 'Key Milestones of the Year',
        defaultSubtitle: 'A look back at the important moments and key achievements of the year',
    },
    // 卡片数据配置
    data: [
        {
            id: 'card-1',
            title: 'Tech Breakthrough',
            subtitle: 'AI Intelligence Upgrade',
            description: 'New AI technology architecture providing smarter, more precise services.',
            image: 'https://picsum.photos/400/300?random=501',
            category: 'Innovation',
            date: 'March 2025',
            link: '#',
        },
        {
            id: 'card-2',
            title: 'User Milestone',
            subtitle: 'Million User Mark',
            description: "User count officially surpassed 1 million, thanks to every user's trust and support.",
            image: 'https://picsum.photos/400/300?random=502',
            category: 'Growth',
            date: 'June 2025',
            link: '#',
        },
        {
            id: 'card-3',
            title: 'Product Upgrade',
            subtitle: 'New UI Design',
            description: 'After months of meticulous design and development, the new user interface is officially released.',
            image: 'https://picsum.photos/400/300?random=503',
            category: 'Product Launch',
            date: 'September 2025',
            link: '#',
        },
        {
            id: 'card-4',
            title: 'Industry Recognition',
            subtitle: 'Awarded Annual Prize',
            description: 'Received "Annual Best Innovation Product" award in industry evaluation, gaining industry recognition.',
            image: 'https://picsum.photos/400/300?random=504',
            category: 'Awards',
            date: 'December 2025',
            link: '#',
        },
        {
            id: 'card-5',
            title: 'Team Expansion',
            subtitle: 'Talent Acquisition',
            description: 'Continuous influx of excellent talent injects new vitality and innovative thinking into company development.',
            image: 'https://picsum.photos/400/300?random=505',
            category: 'Team Building',
            date: 'Throughout 2025',
            link: '#',
        },
        {
            id: 'card-6',
            title: 'Social Responsibility',
            subtitle: 'CSR Project Launch',
            description:
                'Launched multiple public welfare initiatives, giving back to society with technological power to create greater value.',
            image: 'https://picsum.photos/400/300?random=506',
            category: 'Social Contribution',
            date: 'Throughout 2025',
            link: '#',
        },
    ],
};

/**
 * ========== SmartReader组件内容配置 ==========
 */
export const smartReaderContent = {
    // 文案配置
    text: {
        defaultTitle: 'The Future of Information',
        defaultSubtitle: 'Intelligent Reading Experience',
        defaultCategory: 'Annual Report 2025',
    },
    // 文章内容配置
    article: {
        title: 'Advancing Through Innovation',
        subtitle: 'How technology shapes our understanding of progress and modernization in the digital age',
        content: [
            {
                id: 'paragraph-1',
                type: 'paragraph',
                text: "In today's rapidly evolving landscape, the intersection of technology and human progress creates unprecedented opportunities for growth and understanding.",
                highlights: ['technology', 'human progress', 'unprecedented opportunities'],
            },
            {
                id: 'paragraph-2',
                type: 'paragraph',
                text: 'Through strategic innovation and collaborative efforts, organizations worldwide are redefining what it means to create meaningful impact in their communities.',
                highlights: ['strategic innovation', 'collaborative efforts', 'meaningful impact'],
            },
            {
                id: 'paragraph-3',
                type: 'paragraph',
                text: "The convergence of artificial intelligence, sustainable practices, and inclusive design principles forms the foundation of tomorrow's solutions.",
                highlights: ['artificial intelligence', 'sustainable practices', 'inclusive design'],
            },
            {
                id: 'paragraph-4',
                type: 'paragraph',
                text: 'As we look toward the future, the emphasis on data-driven decision making and ethical technology development becomes increasingly vital for long-term success.',
                highlights: ['data-driven decision making', 'ethical technology', 'long-term success'],
            },
            {
                id: 'quote-1',
                type: 'quote',
                text: "Innovation is not just about creating new technologies, but about reimagining how we solve humanity's greatest challenges.",
                author: 'Tech Leadership Council',
            },
            {
                id: 'paragraph-6',
                type: 'paragraph',
                text: 'By fostering environments that encourage experimentation and learning from failure, we cultivate the resilience necessary for sustainable transformation.',
                highlights: ['experimentation', 'learning from failure', 'sustainable transformation'],
            },
            {
                id: 'paragraph-7',
                type: 'paragraph',
                text: 'By fostering environments that encourage experimentation and learning from failure, we cultivate the resilience necessary for sustainable transformation.',
                highlights: ['failure', 'sustainable transformation'],
            },
            {
                id: 'paragraph-8',
                type: 'paragraph',
                text: 'By fostering environments that encourage experimentation and learning from failure, we cultivate the resilience necessary for sustainable transformation.',
                highlights: ['environments', 'learning', 'cultivate'],
            },
            {
                id: 'paragraph-9',
                type: 'paragraph',
                text: 'By fostering environments that encourage experimentation and learning from failure, we cultivate the resilience necessary for sustainable transformation.',
                highlights: ['fostering', 'environments', 'resilience necessary'],
            },
        ],
    },
    // 装饰元素配置
    decorations: {
        scanlineColor: 'rgba(100, 255, 218, 0.6)',
        highlightColor: 'rgba(100, 255, 218, 0.2)',
        particleColor: 'rgba(100, 255, 218, 0.4)',
        progressColor: 'rgba(100, 255, 218, 1)',
        accentColor: '#64FFDA',
    },
};

/**
 * ========== 导出完整配置对象 ==========
 */
export const content = {
    hero: heroContent,
    showcase: showcaseContent,
    statisticsBoard: statisticsBoardContent,
    magneticCards: magneticCardsContent,
    photoFlow: photoFlowContent,
    smartReader: smartReaderContent,
    spotlightGallery: spotlightGalleryContent,
    timeLine: timeLineContent,
    highLight: highLightContent,
    rightPath: rightPathContent,
    productCollection: productCollectionContent,
    navBar: navBarContent,
    app: appContent,
};

export default content;
